const validInputs = () => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach(input => {
        input.addEventListener('blur', event => {
            if (event.target.value) {
                input.classList.add('is-valid');
            } else {
                input.classList.remove('is-valid');
            }
        });
    });
};

export default validInputs;
